import { Link, useNavigate } from "react-router-dom";

export default function VehicleAccessoryTable() {
  const navigate = useNavigate();

  const handleNavigate = (vehicleno) => {
    navigate(`/${vehicleno}`);
  };

  const data = [
    { id: 1, vehicleno: "MH20ER4534", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 2, vehicleno: "Safe Student", accessoryitem: "Side Mirror", quantity: "4", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 3, vehicleno: "MH03AS3945", accessoryitem: "Side Mirror", quantity: "24", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 4, vehicleno: "MH04KL0921", accessoryitem: "Side Mirror", quantity: "45", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 5, vehicleno: "MH05MH5932", accessoryitem: "Side Mirror", quantity: "44", price: "$1245", purchasedate: "Thu Mar 2 2022" },
    { id: 6, vehicleno: "MH06MJ4321", accessoryitem: "Side Mirror", quantity: "4", price: "$3221", purchasedate: "Thu Mar 2 2022" },
    { id: 7, vehicleno: "MH07ND4567", accessoryitem: "Side Mirror", quantity: "5", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 8, vehicleno: "MH08KK4909", accessoryitem: "Side Mirror", quantity: "3", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 9, vehicleno: "MH11KL0008", accessoryitem: "Side Mirror", quantity: "11", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 10, vehicleno: "MH20UI3424", accessoryitem: "Side Mirror", quantity: "12", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 11, vehicleno: "MH20SQ9021", accessoryitem: "Seat Cover", quantity: "34", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 12, vehicleno: "MH23MK8245", accessoryitem: "Cluch Wire", quantity: "13", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 13, vehicleno: "MH24NF5321", accessoryitem: "Break Linear", quantity: "55", price: "$20000", purchasedate: "Thu Mar 2 2022" },
    { id: 14, vehicleno: "MH22PQ4441", accessoryitem: "Engine Oil", quantity: "12", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 15, vehicleno: "MH12EE2323", accessoryitem: "Battery", quantity: "34", price: "$32525", purchasedate: "Thu Mar 2 2022" },
    { id: 16, vehicleno: "MH11FG9090", accessoryitem: "Oil Seal", quantity: "6", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 17, vehicleno: "MH20UI1221", accessoryitem: "Speed Meter", quantity: "9", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 18, vehicleno: "MH20EE0890", accessoryitem: "Tyer", quantity: "22", price: "$1000", purchasedate: "Thu Mar 2 2022" },
    { id: 19, vehicleno: "MH20SQ0987", accessoryitem: "Side Mirror", quantity: "21", price: "$2000", purchasedate: "Thu Mar 2 2022" },
    { id: 20, vehicleno: "MH21XQ0087", accessoryitem: "Side Mirror", quantity: "21", price: "$2000", purchasedate: "Thu Mar 2 2022" },
  ];

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Accessory</h4>
        <div className="yc-header-actions">
          <Link to="/createvehicleaccessory" className="btn btn-primary">
            Create Vehicle Accessory
          </Link>
          <div className="dropdown">
            <button
              id="btnGroupDropExport"
              type="button"
              className="btn btn-primary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Export
            </button>
            <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
              <li><a className="dropdown-item" href="#">Save as PDF</a></li>
              <li><a className="dropdown-item" href="#">Save as CSV</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select className="form-select">
            <option>All</option>
            <option>MH20EE3948</option>
            <option>MH21RE4890</option>
          </select>
          <input type="text" className="form-control" placeholder="Purchase Date" />
          <button type="button" className="btn btn-primary">Clear</button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Vehicle Name/Number</div>
            <div className="yc-list-cell">Accessory Item</div>
            <div className="yc-list-cell">Quantity</div>
            <div className="yc-list-cell">Price</div>
            <div className="yc-list-cell">Purchase Date</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        <div className="yc-list-row-list">
          {data.map((row, idx) => (
            <div key={`${row.id}-${idx}`} className="yc-list-row-card">
              <div className="yc-list-grid yc-list-grid-7">
                <div className="yc-list-cell">{idx + 1}</div>
                <div className="yc-list-cell">{row.vehicleno}</div>
                <div className="yc-list-cell">{row.accessoryitem}</div>
                <div className="yc-list-cell">{row.quantity}</div>
                <div className="yc-list-cell">{row.price}</div>
                <div className="yc-list-cell">{row.purchasedate}</div>
                <div className="yc-list-cell yc-list-cell--actions">
                  <button
                    type="button"
                    className="yc-action-icon"
                    onClick={() => handleNavigate(row.vehicleno)}
                    title="View"
                  >
                    <i className="bi bi-eye"></i>
                  </button>
                  <Link
                    to="/accountant/updatevehicleaccessory"
                    className="yc-action-icon"
                    title="Edit"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </Link>
                  <button
                    type="button"
                    className="yc-action-icon yc-action-icon--danger"
                    title="Delete"
                  >
                    <i className="bi bi-trash3"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
